<template>
    <h1 class="text-lg text-gray-900 dark:text-white font-semibold">Leaks</h1>
    <div class="mt-3">
        <Pagination v-model="filters.page" :total-items="leaks?.totalCount" :items-per-page="filters.limit" />
        <div class="grid grid-cols-2 sm:auto-fill-[160px] md:auto-fill-[190px] gap-3" :class="{'my-4': leaks?.totalCount! > filters.limit}">
            <NuxtLink :to="`/da-hood/leak/${leak.id}`" v-for="leak in leaks?.data" :key="leak.id">
                <Leak class="mt-0" :icon="leak.icon" :name="leak.name" :released="leak.released" :date="leak.createdAt" />
            </NuxtLink>
        </div>
        <Pagination v-model="filters.page" :total-items="leaks?.totalCount" :items-per-page="filters.limit" />
    </div>
</template>

<script setup lang="ts">
import type { Leak } from './index.vue'

interface ApiResponse {
    data: Leak[];
    currentPage: number;
    isFirstPage: boolean;
    isLastPage: boolean;
    previousPage: number | null;
    nextPage: number | null;
    pageCount: number;
    totalCount: number;
}

const filters = ref({
    page: 1,
    limit: 30
})

const { data: leaks } = await useFetch<ApiResponse>('/api/da-hood/leaks', {
    query: {
        page: computed(() => filters.value.page),
        limit: filters.value.limit
    }
})

useSeoMeta({
    title: 'Leaks'
})
</script>